const query = gql`
  query NutritionArticle($slug: String!, $locale: SiteLocale) {
    nutritionArticle(filter: { slug: { eq: $slug } }, locale: $locale) {
      id
      publishDate: _firstPublishedAt
      title
      slug
      _locales
      image {
        responsiveImage(imgixParams: { w: 1280, h: 640, fit: crop }) {
          srcSet
          webpSrcSet
          sizes
          src
          alt
          title
          base64
          width
          height
        }
      }
      excerpt
      introText
      content {
        __typename
        ... on ArticleTextRecord {
          id
          text
        }
        ... on ArticleImageRecord {
          id
          alignment
          squareImage: image {
            url(
              imgixParams: {
                w: 640
                h: 480
                fm: jpg
                fit: crop
                crop: focalpoint
              }
            )
            blurUpThumb
            alt
            title
          }
          rectangularImage: image {
            url(
              imgixParams: {
                w: 768
                h: 384
                fm: jpg
                fit: crop
                crop: focalpoint
              }
            )
            blurUpThumb
            alt
            title
          }
        }
        ... on CheckmarkListRecord {
          id
          listItems
        }
        ... on AsideRecord {
          id
          symbol {
            url
          }
          heading
          text
        }
        ... on PullQuoteRecord {
          quote
          alignment
        }
        ... on WidgetRecord {
          component
        }
      }
      references {
        ... on ReferenceRecord {
          id
          source
          title
          accessDate
        }
      }
      categories {
        id
        name
        slug
      }
      meta: _seoMetaTags {
        tag
        content
        attributes
      }
    }
  }
`

export { query }
